import { PropTypes } from 'prop-types';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import styled from 'styled-components';

import { Icon, Icons } from '@ge/components/icon';
import { Input } from '@ge/components/input';

import { Container, DialogLabel } from './event-dialog-style';

const TimeInput = styled(Container)`
  position: relative;
  padding: 0;
  button {
    position: absolute;
    right: 0;
    top: 0;
    margin: 1px;
    padding: 2px 5px 2px 0;
  }
  input {
    width: 100%;
  }
`;

const TimeIcon = styled(Icon).attrs((props) => ({
  size: 14,
  viewbox: '0 0 512 512',
  icon: Icons.TIME_ICON,
  color: props.theme.analyze.manualAdjustment.eventDialog.editButtonColor,
}))`
  flex-shrink: 0;
  opacity: 0.5;
`;

const StyledInput = styled(Input)`
  &:focus {
    &:before {
      display: none;
    }
  }
  &:active {
    &:before {
      display: none;
    }
  }
`;

const formatTime = (e) => {
  const input = e.target;
  const tempInputValue = input.value;
  const selectionStart = input.selectionStart;

  // Remove Alphabetic and special characters
  let cleanValue = tempInputValue.replace(/[^0-9]/g, '');

  // Add colons after every two digits to match hh:mm:ss format
  if (cleanValue.length > 2) {
    cleanValue = cleanValue.slice(0, 2) + ':' + cleanValue.slice(2);
  }
  if (cleanValue.length > 5) {
    cleanValue = cleanValue.slice(0, 5) + ':' + cleanValue.slice(5);
  }

  // Limit to hh:mm:ss format (max length 8 characters)
  cleanValue = cleanValue.slice(0, 8);

  // Split into hours, minutes, and seconds
  const parts = cleanValue.split(':');
  let hours = parts[0] || '';
  let minutes = parts[1] || '';
  let seconds = parts[2] || '';

  // Validate each part
  if (hours.length === 2) {
    hours = Math.min(parseInt(hours, 10), 23).toString().padStart(2, '0');
  }
  if (minutes.length === 2) {
    minutes = Math.min(parseInt(minutes, 10), 59).toString().padStart(2, '0');
  }
  if (seconds.length === 2) {
    seconds = Math.min(parseInt(seconds, 10), 59).toString().padStart(2, '0');
  }

  // Join the split parts
  const formattedValue = [hours, minutes, seconds].filter(Boolean).join(':');

  // Calculate new cursor position
  let cursorPosition = selectionStart;
  if (formattedValue.length > tempInputValue.length && selectionStart > 2 && selectionStart <= 5) {
    cursorPosition += 1;
  } else if (formattedValue.length > tempInputValue.length && selectionStart > 5) {
    cursorPosition += 1;
  }

  input.value = formattedValue;
  input.setSelectionRange(cursorPosition, cursorPosition);

  return formattedValue;
};

export const MalEventDateSelect = ({ name, label, defaultValue }) => {
  const { control } = useFormContext();

  return (
    <div>
      <DialogLabel>{label}</DialogLabel>
      <Controller
        control={control}
        name={name}
        rules={{
          required: true,
        }}
        defaultValue={defaultValue}
        render={({ value, onChange }) => (
          <TimeInput>
            <StyledInput
              type="text"
              placeholder="hh:mm:ss"
              steps="2"
              value={value}
              onChange={(e) => onChange(formatTime(e))}
            />
            <button type="button">
              <TimeIcon />
            </button>
          </TimeInput>
        )}
      />
    </div>
  );
};

MalEventDateSelect.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  defaultValue: PropTypes.string,
};

MalEventDateSelect.defaultProps = {
  defaultValue: '',
};
